export const LOADING_TEXT = "Loading...";
